<div class="d-flex align-items-center justify-content-between px-4 pt-4">
  <h2 class="m-0">TRANSCRIPTION - <span class="transcriptTitle">{{ data.patient.firstName }} {{ data.patient.lastName
      }}</span></h2>
  <button type="button" mat-icon-button aria-label="close dialog" [mat-dialog-close]="false">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <mat-card class="card">
    <mat-card class="card-header">
      <div class="card-header-content d-flex">
        <div class="head d-flex">
          <span class="tab-icon">
            <img [src]="cvaUI_url + '/assets/icons/record-transcription.svg'" alt="record transcription" />
          </span>
          <p>{{data.start| date:'EEE dd MMM, yyyy - HH:mm' }}</p>
          <button type="button" class="text-danger pointer btn-invisible" (click)="deleteTranscription()">
            <i class="bi bi-trash3"></i>
          </button>
        </div>
      </div>
    </mat-card>
    <mat-card-content class="transcription">
      <div class="main-body">{{data.transcription}}</div>
    </mat-card-content>
  </mat-card>
</mat-dialog-content>